import axios from 'axios';
import Vue from 'vue';
import Errors from '../classes/errors';
import {
    checkCCM19Consent,
    checkOneTrustConsent,
    handleCloseDropdownOnBlur,
    handleCloseInputDropdownOnBlur,
    normalizeModelName,
    setCaptchaEuScript,
} from '../utils';
import { isCaptchaEnabled } from '../services/captcha';
import { getFormRenderToken } from '../services/anti-bot';

Vue.component('fleet-offer-form-component', {
    props: {
        siteHandle: {
            type: String,
        },
        // getBrandStoresForSite() returns a PHP array keyed by store id, which
        // serializes to a JSON object — not an array — so the prop is an Object.
        stores: {
            type: Object,
            default: () => ({}),
        },
        captchaEuPublicKey: {
            type: String,
        },
    },

    data() {
        return {
            formRenderToken: '',
            errors: new Errors(),
            submitting: false,
            successMessage: '',
            selectedBrandStore: null,
            model: '',
        };
    },

    mounted() {
        setCaptchaEuScript();

        getFormRenderToken().then((token) => {
            this.formRenderToken = token;
        });

        handleCloseDropdownOnBlur('.new-input__dropdown-container--model');
        handleCloseInputDropdownOnBlur(
            '#store-dropdown-container',
            '#searchBrandstore',
        );

        EventBus.$on('brandstore-selected', (brandstore) => {
            this.selectedBrandStore = brandstore;
        });
    },

    methods: {
        async onSubmit(event) {
            event.preventDefault();
            const form = event.currentTarget;

            if (this.submitting) return;

            this.submitting = true;
            let isSubmitted = false;

            try {
                const captchaSolution = (await isCaptchaEnabled())
                    ? await KROT.getSolution(this.captchaEuPublicKey)
                    : null;

                isSubmitted = await this.handleDataSubmit(
                    form,
                    captchaSolution,
                );
            } finally {
                if (!isSubmitted) {
                    this.submitting = false;
                }
            }
        },

        async handleDataSubmit(form, captchaSolution = null) {
            const formData = new FormData(form);
            formData.append('formRenderToken', this.formRenderToken);
            if (captchaSolution) {
                formData.append(
                    'captchaSolution',
                    JSON.stringify(captchaSolution),
                );
            }

            const response = await axios.post('/', formData);
            const result = response.data;

            if (result.data?.errors) {
                this.errors.clear();
                this.errors.record(result.data.errors);
                return false;
            }

            this.errors.clear();
            this.sendGTMData(formData);

            if (!result.data?.redirectUrl) {
                this.successMessage = result.data?.['form-general-success'] ?? '';
                return true;
            }

            window.location = result.data.redirectUrl;
            return true;
        },

        sendGTMData(formData) {
            if (!checkCCM19Consent() && !checkOneTrustConsent()) return;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'lead',
                lead_type: 'Fleet Offer',
                client_type: 'B2B',
                unique_form_id: crypto.randomUUID(),
                brandstore: this.selectedBrandStore
                    ? this.selectedBrandStore.title
                    : '',
                payment_type: '',
                car: {
                    name: normalizeModelName(this.model, this.siteHandle),
                    ids: [],
                    edition: '',
                    color: '',
                },
                user_data: {
                    email_address: formData.get('emailAddress'),
                    phone_number: formData.get('phone'),
                    address: {
                        first_name: formData.get('firstName'),
                        last_name: formData.get('lastName'),
                    },
                },
            });
        },
    },
});
